__turbopack_context__.v({
  "container": "snackbar-item-module-scss-module__4UZ8qW__container",
  "first": "snackbar-item-module-scss-module__4UZ8qW__first",
  "hide": "snackbar-item-module-scss-module__4UZ8qW__hide",
  "second": "snackbar-item-module-scss-module__4UZ8qW__second",
  "third": "snackbar-item-module-scss-module__4UZ8qW__third",
});
